var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import ProjectInfo from '../home/ProjectInfo.vue';
import Cta from '../shared/Cta.vue';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
let ProjectDetails = class ProjectDetails extends Vue {
    setFocusTrap() {
        setTimeout(() => {
            const closeBtn = this.$refs.closeButton;
            const ctaEl = this.$refs.ctaComponent;
            const ctaLink = ctaEl.$refs.ctaLink;
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Tab') {
                    if (e.shiftKey) {
                        if (document.activeElement === closeBtn) {
                            ctaLink.focus();
                            e.preventDefault();
                        }
                    }
                    else {
                        if (document.activeElement === ctaLink) {
                            closeBtn.focus();
                            e.preventDefault();
                        }
                    }
                }
            });
        }, 200);
    }
    onClose(event, _projectId) {
        if (event.screenX === 0 && event.screenY === 0) {
            this.$emit('onCloseWithFocus', _projectId);
        }
        else {
            this.$emit('onClose');
        }
    }
    onCloseWithFocus(_projectId) { }
    get sectors() {
        return this.activeProject && this.activeProject.sector ? this.activeProject.sector.map(function (sector) {
            return sector.title;
        }).join(", ") : "";
    }
};
__decorate([
    Prop({ type: Object })
], ProjectDetails.prototype, "labels", void 0);
__decorate([
    Prop()
], ProjectDetails.prototype, "activeProject", void 0);
__decorate([
    Prop()
], ProjectDetails.prototype, "projectDetailClass", void 0);
__decorate([
    Watch('activeProject')
], ProjectDetails.prototype, "setFocusTrap", null);
__decorate([
    Emit('onCloseWithFocus')
], ProjectDetails.prototype, "onCloseWithFocus", null);
ProjectDetails = __decorate([
    Component({
        components: {
            ProjectInfo,
            Cta
        }
    })
], ProjectDetails);
export default ProjectDetails;
